import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../../src/pages/client/client_assets/css/common.css';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import config from '../../../config/config.js';

function Blog() {
  const [value, setValue] = useState('');
  const [categories, setCategories] = useState([]); 
  const [category, setCategory] = useState('LIFE STYLE'); // Default to 0, category not stored in DB
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  // const {blodData, setBlogData} =useState();
  // Fetch categories from the backend
  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${config.API_BASE_URL}/get_categories.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (data.success) {
          setCategories(data.categories || []);
        } else {
          toast.error(data.message || 'Failed to load categories.');
        }
      } catch (error) {
        toast.error('Error fetching categories.');
        console.error('Error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Fetch tags from the backend
  useEffect(() => {
    const fetchTags = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${config.API_BASE_URL}/get_tags.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();

        if (data.success) {
          setTags(data.categories || []);
        } else {
          toast.error(data.message || 'Failed to load tags.');
        }
      } catch (error) {
        toast.error('Error fetching tags.');
        console.error('Error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTags();
  }, []);

  const modules = {
    toolbar: {
      container: [
        [{ 'font': ['sans-serif', 'opensans', 'montserrat', 'poppins'] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link', 'image', 'video'],
        ['clean'],
      ],
    },
  };

  const generateFileName = (file) => {
    const timestamp = Date.now();
    const fileExtension = file.name.split('.').pop();
    return `${timestamp}_${file.name.replace(/\s+/g, '_').toLowerCase()}.${fileExtension}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate all required fields
    const title = e.target.title.value;
    const slug = e.target.slug.value;
  
    if (!category || category === '0') {
      toast.error('Please select a category.');
      return;
    }
    if (!selectedTags.length) {
      toast.error('Please select at least one tag.');
      return;
    }
    if (!title) {
      toast.error('Title is required.');
      return;
    }
    if (!slug) {
      toast.error('Slug is required.');
      return;
    }
    if (!value) {
      toast.error('Content is required.');
      return;
    }
    if (!e.target.image1.files.length) {
      toast.error('Image 1 is required.');
      return;
    }
    if (!e.target.image2.files.length) {
      toast.error('Image 2 is required.');
      return;
    }
    if (!e.target.image3.files.length) {
      toast.error('Image 3 is required.');
      return;
    }
  
    // Get the logged-in user's ID from localStorage
    const user = localStorage.getItem('user');
    let userId = '';
    try {
      const parsedUser = JSON.parse(user); 
      userId = parsedUser.id; 
    } catch (error) {
      toast.error('Error parsing user data.');
      console.error('Error parsing user:', error);
      return;
    }
  
    const formData = new FormData(e.target);
  
    // Set the category to the selected value (no need to reset it)
    formData.append('category', category); // Using the actual selected category
  
    formData.append('tags', selectedTags.join(',')); 
    formData.append('content', value);
    formData.append('added_on', new Date().toISOString());
    formData.append('user_id', userId);  // Include the logged-in user's ID
  
    // Modify file names before appending
    const files = ['image1', 'image2', 'image3'];
    files.forEach((fileField) => {
      const file = e.target[fileField].files[0];
      if (file) {
        const newFileName = generateFileName(file);
        formData.append(fileField, file, newFileName);  // Append the file with a modified name
      }
    });
  
    setIsLoading(true);
  
    try {
      const response = await fetch(`${config.API_BASE_URL}/blog.php`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
  
      if (data.success) {
        toast.success('Blog created successfully!');
      } else {
        toast.error(data.message || 'Failed to create blog.');
      }
    } catch (error) {
      toast.error('An error occurred while submitting the form.');
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // const blogData = 


  const [blogData,setblogData] = useState(
    [
      {sno:1, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"},
      {sno:2, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"},
      {sno:1, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"},
      {sno:1, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"},
      {sno:1, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"},
      {sno:1, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"},
      {sno:1, category:"Life Style",date:"22-2-2025", title:"Beauty",tags:"lifestyle", content:"this is test content"}
    
    ]
  )

  // const handleEdit = (data)=>{
  //   setblogData(data)
  // }
  return (
    <>
      <div className="container-fluid category_form_sec mb-5">
        <h1 className="dashboard_heading">Blog</h1>

        <form onSubmit={handleSubmit}>

          <div className='row'>
          {/* Category Select */}
          {/* <div className="form-group mt-4"> */}
            <div className="category_wrapper">
              <div className="category_select">
                <label htmlFor="Category">Category</label>
                <Form.Select
                  aria-label="Category"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  disabled={isLoading}
                >
        
                  {categories.length > 0 && categories.map((cat, index) => (
                    <option key={index} value={cat.name}>
                      {cat.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
          {/* </div> */}

          {/* Date Picker */}
          {/* <div className="form-group mt-4"> */}
            <div className="data_select">
              <label htmlFor="Category">Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs} className="data_select">
                <DemoContainer components={['DatePicker']}>
                  <DatePicker />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </div>

           <div className='row'>
              <div  className="file_upload">
                <Form.Group>
                  <Form.Label>Image 1 <span>(424 px X 550 px)</span></Form.Label>
                  <Form.Control type="file" required name="image1" />
                </Form.Group>
              </div>

            <div className='file_upload'>
              <Form.Group>
                <Form.Label>Image 2 <span>(394 px X 256 px)</span></Form.Label>
                <Form.Control type="file" required name="image2" />
              </Form.Group>
            </div>
         
         
          <Form.Group className="file_upload">
            <Form.Label>Image 3 <span>(240 px X 220 px)</span></Form.Label>
            <Form.Control type="file" required name="image3" />
          </Form.Group>
          </div>

          {/* Title and Slug */}
          <Row>
            <Col md={6}>
              <div className=" ">
                <label htmlFor="title">Title</label>
                <input type="text" name="title" id="title" className="form-control bg-white" required />
              </div>
            </Col>
            <Col md={6}>
              <div className=" ">
                <label htmlFor="slug">Slug</label>
                <input type="text" name="slug" id="slug" className="form-control bg-white" required />
              </div>
            </Col>
          </Row>

          {/* Tags */}
          <div className=" choose_tags">
            <label htmlFor="tags">Tags</label>
            <Form.Select
              multiple
              aria-label="Tags"
              value={selectedTags}
              onChange={(e) => setSelectedTags(Array.from(e.target.selectedOptions, option => option.value))}
              disabled={isLoading}
              required
            >
              {tags.length > 0 ? (
                tags.map((tag, index) => (
                  <option key={index} value={tag.id}>
                    {tag.name}
                  </option>
                ))
              ) : (
                <option>No tags available</option>
              )}
            </Form.Select>
          </div>

          {/* Content */}
          <div className=" choose_tags">
            <label htmlFor="content">Content</label>
            <ReactQuill value={value} onChange={setValue} modules={modules} required />
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn btn-success mt-5" disabled={isLoading}>
            {isLoading ? 'Submitting...' : 'Create Blog'}
          </button>
        </form>

              <div className="content_wrapper blog_wrapper">
                <div className="table table-responsive">
                      <tr>
                        <th>S.No</th>
                        <th>Category</th>
                        <th>Date</th>
                        <th>Title</th>
                        <th>Tags</th>
                        <th>Content</th>
                        <th>Actions</th>
                      </tr>

                      {/* <tr> */}
                    {

                      blogData.length>0 ?( blogData.map((data,index)=>(
                             <tr key={index}>
                              <td>{data.sno}</td>
                              <td>{data.category}</td>
                              <td>{data.date}</td>
                              <td>{data.title}</td>
                              <td>{data.tags}</td>
                              <td>{data.content}</td>
                              <td>
                                  <div className='action_btn bg-transparent'>
                                    <div className='' style={{marginRight:"20px", color:"#0d6efd"}} 
                                     >Edit</div>
                                    <div className='' style={{color:"#dc3545"}} >Delete</div>
                                  </div>
                              </td>

                          </tr>
                      ))) :  (
                          <tr>
                            <td>No data available</td>
                           </tr>
                        )
                    }
                        {/* <td>
                        <div className='action_btn'>
                          <div className='' style={{marginRight:"20px", color:"#0d6efd"}} onClick={()=>handleEdit(category)}>Edit</div>
                          <div className='' style={{color:"#dc3545"}} onClick={(event) => handleDelete(category.id, event)}>Delete</div>
                        </div>
                      </td> */}
                      {/* </tr> */}
                </div>
              </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Blog;
